import React, { createContext, useState } from "react";

export interface ITvSeriesDashboardContext {
    selectedEpisode?: { id: string; title: string };
    selectedSeason?: { id: string; name: string };
    currentPage: "tvSeriesPage" | "seasonPage" | "episodePage";
    selectTvSeriesPage(): void;
    selectCurrentSeason(seasonId: string, seasonName: string): void;
    selectCurrentEpisode(episodeId: string, episodeTitle: string): void;
}

const defaultTvSeriesDashboardContext: ITvSeriesDashboardContext = {} as ITvSeriesDashboardContext;

export const TvSeriesDashboardContext = createContext<ITvSeriesDashboardContext>(defaultTvSeriesDashboardContext);

type TvSeriesDashboardProviderProps = React.PropsWithChildren<unknown>;

export const TvSeriesDashboardProvider: React.FunctionComponent<TvSeriesDashboardProviderProps> = ({
    children
}: TvSeriesDashboardProviderProps) => {
    const [selectedSeason, setSelectedSeason] = useState<{ id: string; name: string } | undefined>();
    const [selectedEpisode, setSelectedEpisode] = useState<{ id: string; title: string } | undefined>();
    const [currentPage, setCurrentPage] = useState<"tvSeriesPage" | "seasonPage" | "episodePage">("tvSeriesPage");

    const selectTvSeriesPage = () => {
        setSelectedEpisode(undefined);
        setSelectedSeason(undefined);
        setCurrentPage("tvSeriesPage");
    };

    const selectCurrentSeason = (seasonId: string, seasonName: string) => {
        setSelectedSeason({ id: seasonId, name: seasonName });
        setCurrentPage("seasonPage");
        setSelectedEpisode(undefined);
    };

    const selectCurrentEpisode = (episodeId: string, episodeTitle: string) => {
        if (selectedSeason) {
            setSelectedEpisode({ id: episodeId, title: episodeTitle });
            setCurrentPage("episodePage");
        }
    };

    return (
        <TvSeriesDashboardContext.Provider
            value={{
                selectedEpisode,
                selectedSeason,
                currentPage,
                selectCurrentSeason,
                selectCurrentEpisode,
                selectTvSeriesPage
            }}
        >
            {children}
        </TvSeriesDashboardContext.Provider>
    );
};
